import React from 'react';
import block from 'propmods';
import ReactToggle, { ToggleProps } from 'react-toggle';

import './Toggle.scss';

const b = block('Toggle');

const Toggle: React.FC<ToggleProps> = (props) => {
    return (
        <div {...b()}>
            <ReactToggle {...props} />
        </div>
    );
};

export default Toggle;
